import React, { lazy } from "react";

import type { LottieComponentProps } from "lottie-light-react";
import SSRSuspense from "../SSRSuspense/SSRSuspense";
const LazyLottie = lazy(() => import("lottie-light-react"));

export interface ClientSideLottieProps extends LottieComponentProps {
    ariaHidden?: boolean;
}
export const ClientSideLottie: React.FC<ClientSideLottieProps> = ({
    animationData,
    loop,
    ariaHidden,
    autoPlay,
    lottieRef,
    style,
    className,
    children
}) => {
    return (
        <SSRSuspense>
            <LazyLottie
                animationData={animationData}
                loop={loop}
                aria-hidden={ariaHidden}
                autoPlay={autoPlay}
                lottieRef={lottieRef}
                style={style}
                className={className}
            >{children}</LazyLottie>
        </SSRSuspense>
    );
};